import { GETTING_STAFF, GET_STAFF, ONBOARDING_STAFF, ONBOARD_STAFF, RESENDING_INVITATION, RESEND_INVITATION, REVOKING_INVITATION, REVOKE_INVITATION, STAFF_ERROR, UPDATED_STAFF, UPDATING_STAFF } from "../types"

const initialState = {
    staffMembers: [],
    loadingStaff: true,
    staffError: null,
    onboardingStaff: false,
    onboardedStaff: null,
    updatingStaff: false,
    updatedStaff: null,
    resendingInvitation: null,
    resentInvitation : null,
    revokingInvitation: null,
    revokedInvitation: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_STAFF:
        return {
            ...state,
            loadingStaff :action.payload,
        }
        case GET_STAFF:
        return{
            ...state,
            loadingStaff: false,
            staffError: null,
            staffMembers: action.payload,
        }
        case ONBOARDING_STAFF:
        return {
            ...state,
            onboardingStaff: action.payload,
        }
        case ONBOARD_STAFF:
        return{
            ...state,
            onboardingStaff: false,
            staffError: null,
            onboardedStaff: action.payload,
        }
        case UPDATING_STAFF:
        return {
            ...state,
            updatingStaff: action.payload,
        }
        case UPDATED_STAFF:
        return{
            ...state,
            loadingStaff: false,
            updatingStaff:false,
            staffError: null,
            updatedStaff: action.payload,
        }
        case RESENDING_INVITATION:
            // console.log('resending invitation: ', action.payload)
        return {
            ...state,
            resendingInvitation: action.payload,
            // fetchingMembers:false
        }
        case RESEND_INVITATION:
        return{
            ...state,
            resendingInvitation: null,
            staffError: false,
            resentInvitation: action.payload,
        }
        case REVOKING_INVITATION:
        return {
            ...state,
            revokingInvitation: action.payload,
            // fetchingMembers:false
        }
        case REVOKE_INVITATION:
        return{
            ...state,
            revokingInvitation: null,
            staffError: false,
            revokedInvitation: action.payload,
        }
        case STAFF_ERROR:
        return{
            ...state,
            loadingStaff: false,
            updatingStaff:false,
            onboardingStaff: false,
            staffError: action.payload 
        }
        default: return state
    }

}